import type { CSSProperties } from "react"

import { tailwindPalette, TailwindPalette } from "../../../../../theme/tailwindPalette"
import { ResourceType } from "../../../../admin/organization/resources/resourcesTypes"

export const ALL_RESOURCE_TYPES = "ALL"
export type ResourceTypeSelection = ResourceType | typeof ALL_RESOURCE_TYPES

// Stable display/order of the resource types across every dashboard (chart, sections, hero).
export const DASHBOARD_RESOURCE_TYPES: ReadonlyArray<ResourceType> = [
    ResourceType.ROOM,
    ResourceType.MOBILE_AV,
    ResourceType.CAR,
]

// Minimal shape every dashboard entry must expose so the shared chart/section can label and route it.
export type ResourceDisplay = Readonly<{ id: number; displayName: string }>
export type ResourceEntry = Readonly<{ resource: ResourceDisplay }>

// A metric entry (occupancy rate, booking summary, …) tagged with its resource type so the shared
// chart/section can colour and route each row/bar by type.
export type DashboardResourceEntry<TEntry extends ResourceEntry = ResourceEntry> = Readonly<
    TEntry & {
        resourceType: ResourceType
    }
>

// Status variants shared with the occupancy report (`status.variant`) and `StandardChip`.
export type ResourceStatusVariant = "success" | "yellow" | "red"

const STATUS_COLOR_FAMILY: Readonly<Record<ResourceStatusVariant, keyof TailwindPalette>> = {
    success: "green",
    yellow: "amber",
    red: "red",
}

// Maps a resource's health status to its bar colour (chart + table), keeping the chip and the bar in sync.
export function statusColor(variant: ResourceStatusVariant): string {
    return tailwindPalette[STATUS_COLOR_FAMILY[variant]][500]
}

export function isResourceType(value: ResourceTypeSelection): value is ResourceType {
    return value !== ALL_RESOURCE_TYPES
}

export function cssVars(vars: Readonly<Record<`--${string}`, string | number>>): CSSProperties {
    return vars as CSSProperties
}
